import PropTypes from 'prop-types';
import styles from '@shared/components/atoms/StatusBadge/StatusBadge.module.scss';
// 상태 정규화
function normalizeState(state) {
  if (state === null || state === undefined) return null;

  if (typeof state === 'number') return state;

  const str = String(state).trim();

  if (str.includes('임시')) return 0;
  if (str.includes('대기')) return 1;
  if (str.includes('결재중') || str.includes('진행')) return 2;
  if (str.includes('완료')) return 3;
  if (str.includes('반려')) return 4;
  if (str.includes('수정요청')) return 6;
  if (str.includes('관리자취소')) return 7;

  return null;
}

const STATE_LABEL_BY_CODE = {
  0: '임시저장',
  1: '결재 대기',
  2: '결재중',
  3: '결재완료',
  4: '반려',
  6: '수정요청',
  7: '관리자취소',
};

const BADGE_CLASS_BY_STATE = {
  0: styles.default,
  1: styles.yellow,
  2: styles.yellow,
  3: styles.green,
  4: styles.red,
  6: styles.red, // 수정요청도 반려와 동일한 빨간색
  7: styles.default,
};

export default function StatusBadge({ state, className, isCompleted }) {
  const normalized = normalizeState(state);
  const label = typeof state === 'string' ? state : (STATE_LABEL_BY_CODE[normalized] ?? '');

  const badgeClass = isCompleted
    ? styles.gray
    : (BADGE_CLASS_BY_STATE[normalized] ?? styles.default);

  return <span className={`${styles.badge} ${badgeClass} ${className ?? ''}`}>{label}</span>;
}

StatusBadge.propTypes = {
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  isCompleted: PropTypes.bool,
};
StatusBadge.defaultProps = {
  isCompleted: false,
};
